<template>
    <v-dialog
        v-model="dialogState"
        width="500"
    >
        <v-card class="d-flex flex-column pa-5 align-content-space-between flex-wrap" v-if="company">
            <v-avatar tile size="150" :color="(company.logo) ? 'white' : 'primary'" class="mb-2 ml-auto mr-auto">
                <v-img
                    v-if="company.logo"
                    :src="company.logo.url"
                    :alt="company.name"
                    contain
                    height="150"
                ></v-img>
                <span class="white--text headline" v-else>{{ company.name | initialName }}</span>
            </v-avatar>

            <v-card-title>
                <h3 class="headline mb-2">{{ company.name }}</h3>
            </v-card-title>

            <v-card-text>
                <p>{{ company.profile }}</p>
                <h4 class="headline mb-2">Benefícios</h4>
                <p>{{ company.about }}</p>
                <div>
                    Entre em contato:
                    <a :href="'mailto:' + company.contact">{{ company.contact }}</a>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'detail-benefit',
    props: ['dialog', 'company'],
    data () {
        return {
            dialogState: null
        }
    },
    watch: {
        company: function (val, oldVal) {
            if (val != null) this.dialogState = true
        },
        dialogState: function (val, oldVal) {
            this.$emit('update:dialog', val)
        }
    }
}
</script>
